import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Upload,
  UploadFile,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import styles from "./SupplierList.module.css";

type Props = {
  visible: boolean;
  onSubmit: (formData: any) => void;
  onCancel: () => void;
};

export type RequestQuationForm = {
  ItemName: string;
  ItemValue: string;
  ItemUnit: string;
  DateOfRequestment: Date;
  ItemPic: UploadFile[];
  Contact: string;
  EndOfQuotationDate: Date;
};

const RequestOfferDialog = ({ visible, onSubmit, onCancel }: Props) => {
  const [form] = useForm<RequestQuationForm>();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined rev={undefined} />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  return (
    <Modal
      visible={visible}
      closable={false}
      width={"50%"}
      title={
        <div
          style={{
            backgroundColor: "#C95559",
            color: "white",
            fontSize: "1.3rem",
            fontWeight: "bold",
            padding: "6px 6px 6px 10px",
          }}
        >
          ระบุข้อมูลสินค้าที่ต้องการใบเสนอราคา
        </div>
      }
      footer={null}
    >
      <Form form={form} validateTrigger={"onFinish"} onFinish={onSubmit}>
        <Form.Item
          label="ชื่อสินค้า/บริการที่ต้องการ :"
          rules={[{ required: true }]}
          name={"ItemName"}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="จำนวน :"
          name={"ItemValue"}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="หน่วยนับ :"
          name={"ItemUnit"}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="วันที่ต้องการสินค้า/บริการ :"
          name={"DateOfRequestment"}
          rules={[{ required: true }]}
        >
          <DatePicker />
        </Form.Item>
        <Form.Item
          label="แนบรูปตัวอย่างสินค้า :"
          name={"ItemPic"}
          rules={[{ required: true }]}
        >
          <Upload multiple listType="picture-card" beforeUpload={undefined}>
            {uploadButton}
          </Upload>
        </Form.Item>
        <Form.Item
          label="ช่องทางการติดต่อกลับ :"
          name={"Contact"}
          rules={[{ required: true }]}
        >
          <TextArea />
        </Form.Item>
        <Form.Item
          label="วันที่ปิดรับข้อเสนอ :"
          name={"EndOfQuotationDate"}
          rules={[{ required: true }]}
        >
          <DatePicker />
        </Form.Item>

        <div className={styles.form_footer}>
          <Button
            type="ghost"
            style={{
              backgroundColor: "#C95559",
              color: "white",
              width: "200px",
              borderRadius: "4px",
              fontWeight: "bold",
              fontSize: "1.1rem",
              height: "50px",
            }}
            htmlType="button"
            size="large"
            onClick={onCancel}
          >
            ยกเลิก
          </Button>
          <Button
            type="primary"
            style={{
              width: "200px",
              backgroundColor: "#6598F6",
              color: "white",
              borderRadius: "4px",
              fontWeight: "bold",
              fontSize: "1.1rem",
              height: "50px",
            }}
            htmlType="submit"
            size="large"
          >
            ส่งคำขอใบเสนอราคา
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default RequestOfferDialog;
